import {
  getCurrentTermsAndConditions,
  newTermsAndConditionsAvailable,
} from "@recare/core/model/careproviders";
import { getStaticAsset } from "@recare/core/model/config";
import { Careprovider } from "@recare/core/types";
import { FormWatcher, isValid } from "@recare/react-forms-state";
import { useTranslations } from "@recare/translations";
import { TranslationComposition } from "@recare/translations/helpers";
import CheckboxInputField from "ds/components/CheckboxInputField";
import InfoCaption from "ds/components/InfoCaption";
import { dp, margin } from "ds/materials/metrics";
import { Body, Link } from "ds/materials/typography";
import { useCountry } from "reduxentities/selectors/hooks";
import styled from "styled-components";

const TermsAndConditionsText = styled.div`
  flex: 1 1 auto;
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  align-self: center;
`;

const TermsAndConditionsBox = styled.div`
  margin: ${margin(2, 3)};
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
`;

export const TermsAndConditions = ({
  careprovider,
}: {
  careprovider: Careprovider;
}) => {
  const country = useCountry();
  const translations = useTranslations();
  const version = careprovider?.terms_and_conditions?.version;
  const newerVersionAvailable = newTermsAndConditionsAvailable({
    version,
    country,
  });

  if (!newerVersionAvailable) return null;

  const { asset } = getCurrentTermsAndConditions(careprovider);

  return (
    <>
      <TermsAndConditionsBox>
        <CheckboxInputField
          width={dp(20)}
          elementName="terms_and_conditions"
          label=""
        />
        <FormWatcher watchPath="terms_and_conditions">
          {({ watchedValidation }) => (
            <TermsAndConditionsText>
              <Body error={!isValid(watchedValidation)}>
                <TranslationComposition
                  translations={translations.termsAndConditions.accept}
                  withOptions
                >
                  {([before, link, after]) => (
                    <>
                      {before}
                      <Link
                        href={getStaticAsset(asset)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          margin: "0px",
                        }}
                      >
                        {link}
                      </Link>
                      {after}
                    </>
                  )}
                </TranslationComposition>
              </Body>
            </TermsAndConditionsText>
          )}
        </FormWatcher>
      </TermsAndConditionsBox>
      {newerVersionAvailable && (
        <InfoCaption
          text={translations.legal.differencesInTCVersions}
          margin={margin(0, 3)}
        />
      )}
    </>
  );
};
